module.exports = __webpack_public_path__ + "static/media/icon2.b7eae054.png";